export function kToLbs(pK: number) {
    return (pK / 0.45359237).toFixed(1);
}
